module.exports = __webpack_public_path__ + "static/GlitchlessSonyax5d-26d9dd191e7d34729767448c780d7e9b.png";